import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import image from "../assets/cart.png";

const CartButton = () => {
    return (
        <Link to={`/user-carts`}>
            <motion.button
                className="fixed bottom-12 right-10 z-20 bg-orange-400 text-white border-none rounded-full w-14 h-14 flex justify-center items-center cursor-pointer transition-colors duration-300 ease-in-out"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
            >
                <img src={image} alt="cart" className='w-8 h-8' />
            </motion.button>
        </Link>
    );
};

export default CartButton;
